module.exports = __webpack_public_path__ + "images/sgp/SGPHero/self-storage-lockers-hero.webp";